import { lazy, Suspense } from 'react'; 
import { Route, Routes } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import Layout from './components/Layout';
import Seite from './components/Seite';

import Schriftstellerei from './components/Schriftstellerei';
import KinoTheater from './components/KinoTheater';
import Contacts from './components/Contacts';
import Krug from './components/Krug';

// import News from './components/News';
const News = lazy(() => import('./components/News'));
const Ideology = lazy(() => import('./components/Ideology'));
const Auslandsamt = lazy(() => import('./components/Auslandsamt'));
const Bewertungen = lazy(() => import('./components/Bewertungen'));

const SohnLuzifers = lazy(() => import('./components/SohnLuzifers'));
const Gedichte = lazy(() => import('./components/Gedichte'));
const Tagebucher = lazy(() => import('./components/Tagebucher'));
const Gefangnis = lazy(() => import('./components/Gefangnis'));
const Drehbuch = lazy(() => import('./components/Drehbuch'));
const Lieder = lazy(() => import('./components/Lieder'));
const Woche = lazy(() => import('./components/Woche'));

const SohnLuzifersKTL = lazy(() => import('./components/SohnLuzifersKTL'));
const GedichteKTL = lazy(() => import('./components/GedichteKTL'));
const Zombi = lazy(() => import('./components/Zombi'));

const Museum = lazy(() => import('./components/Museum'));
const GedichteSPM = lazy(() => import('./components/Museum/GedichteSPM'));
const Lesungen = lazy(() => import('./components/Museum/Lesungen'));
const Antiwelt = lazy(() => import('./components/Museum/Lesungen/Antiwelt'));
const Teufel = lazy(() => import('./components/Museum/Lesungen/Teufel'));
const Zombie = lazy(() => import('./components/Museum/Lesungen/Zombie'));
const Gefangnis123 = lazy(() => import('./components/Museum/Gefangnis123'));
const Gefangnis2011 = lazy(() => import('./components/Museum/Gefangnis123/Gefangnis2011'));
const Gefangnis2 = lazy(() => import('./components/Museum/Gefangnis123/Gefangnis2'));
const Gefangnis2009 = lazy(() => import('./components/Museum/Gefangnis123/Gefangnis2009'));
const Gefangnis2012 = lazy(() => import('./components/Museum/Gefangnis123/Gefangnis2012'));
const Polwirt = lazy(() => import('./components/Museum/Polwirt'));
const Politik1 = lazy(() => import('./components/Museum/Polwirt/Politik1'));
const Politik2 = lazy(() => import('./components/Museum/Polwirt/Politik2'));
const Publizistik = lazy(() => import('./components/Museum/Polwirt/Publizistik'));
const GeschichteRF = lazy(() => import('./components/Museum/Polwirt/GeschichteRF'));
const Pyrammmida = lazy(() => import('./components/Museum/Pyrammmida'));
const Pesenki = lazy(() => import('./components/Museum/Pesenki'));
const MusikSerien = lazy(() => import('./components/Museum/MusikSerien'));
const Andere = lazy(() => import('./components/Museum/Andere'));
const IdeologyKim = lazy(() => import('./components/Museum/Andere/IdeologyKim'));

const LK = lazy(() => import('./components/LK'));
const Favoriten = lazy(() => import('./components/Favoriten'));
const SearchResults = lazy(() => import('./components/SearchResults'));

const Wos = lazy(() => import('./components/Wos'));
const Krug13 = lazy(() => import('./components/Krug/Krug13'));
const IdeologyK = lazy(() => import('./components/IdeologyK'));

const Jack = lazy(() => import('./components/SohnLuzifers/Jack'));
const Anfang = lazy(() => import('./components/SohnLuzifers/Anfang'));
const Gefangnistagebucher = lazy(() => import('./components/Gefangnis/Gefangnistagebucher'));
const Karzer = lazy(() => import('./components/Gefangnis/Karzer'));
const Zweiundvierzig = lazy(() => import('./components/Gefangnis/Zweiundvierzig'));
const Gazprom = lazy(() => import('./components/Gefangnis/Gazprom'));
const Zombi1 = lazy(() => import('./components/Zombi/Zombi1'));
const Zombi2 = lazy(() => import('./components/Zombi/Zombi2'));
const Zombi3 = lazy(() => import('./components/Zombi/Zombi3'));

const generateRoutes = () => {
  const files = {
    ...import.meta.glob("./components/Gedichte/Gedicht*.tsx"),
    ...import.meta.glob("./components/SohnLuzifers/Tag*.tsx"),
    ...import.meta.glob("./components/Tagebucher/Tagebuch*.tsx"),
    ...import.meta.glob("./components/Drehbuch/Szenarium*.tsx"),
    ...import.meta.glob("./components/Lieder/Lied*.tsx"),
    ...import.meta.glob("./components/Woche/Zeitung*.tsx"),
    ...import.meta.glob("./components/SohnLuzifersKTL/KTLTag*.tsx"),
    ...import.meta.glob("./components/GedichteKTL/KTLGedicht*.tsx"),
    ...import.meta.glob("./components/News/News*.tsx"),
    ...import.meta.glob("./components/Auslandsamt/Post*.tsx"),
    ...import.meta.glob("./components/Museum/GedichteSPM/SPMGedicht*.tsx"),
    ...import.meta.glob("./components/Museum/Polwirt/Pub*.tsx"),
    ...import.meta.glob("./components/Museum/MusikSerien/MS*.tsx"),

  };

  return Object.keys(files).map((filePath) => {
    const match = filePath.match(/components\/(.+)\/([^/]+)\.tsx$/);
    if (!match) return null;

    const [, folderPath, fileName] = match; 
    let routePath;

    if (folderPath.includes("SohnLuzifersKTL")) {
      routePath = `/kinotheater/sohnluzifers/${fileName.toLowerCase()}`;
    } else if (folderPath.includes("GedichteKTL")) {
      routePath = `/kinotheater/gedichte/${fileName.toLowerCase()}`;
    } else if (folderPath.includes("Museum/GedichteSPM")) {
      routePath = `/museum/gedichtespm/${fileName.toLowerCase()}`;
    } else if (folderPath.includes("Museum/Polwirt")) {
      routePath = `/museum/polwirt/publizistik/${fileName.toLowerCase()}`;
    } else if (folderPath.includes("Museum/MusikSerien")) {
      routePath = `/museum/musikserien/${fileName.toLowerCase()}`;
    } else if (
      ["Gedichte", "SohnLuzifers", "Tagebucher", "Drehbuch", "Gefangnis", "Lieder", "Woche"]
        .some((f) => folderPath.includes(f))
    ) {
      const mainFolder = folderPath.split("/")[0]; 
      routePath = `/schriftstellerei/${mainFolder.toLowerCase()}/${fileName.toLowerCase()}`;
    } else {
      routePath = `/${folderPath.toLowerCase()}/${fileName.toLowerCase()}`;
    }

    
    const Component = lazy(() =>
      files[filePath]().then((module) => ({
        default: (module as { default: React.ComponentType }).default,
      }))
    );

    return <Route key={routePath} path={routePath} element={<Component />} />;
  }).filter(Boolean);
};

const App: React.FC = () => {
  return (    
    <HelmetProvider>
    <div id="body">
      <Suspense fallback={<div>...</div>}>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Seite />} />


            <Route path="schriftstellerei" element={<Schriftstellerei />} />
            <Route path="kinotheater" element={<KinoTheater />} />
            <Route path="contacts" element={<Contacts />} />
            <Route path="privacy" element={<Krug />} />

            <Route path="news" element={<News />} />
            <Route path="ideology" element={<Ideology />} />
            <Route path="/auslandsamt" element={<Auslandsamt />} />
            <Route path="bewertungen" element={<Bewertungen />} />

            <Route path="/schriftstellerei/sohnluzifers" element={<SohnLuzifers />} />
            <Route path="/schriftstellerei/gedichte" element={<Gedichte />} />
            <Route path="/schriftstellerei/tagebucher" element={<Tagebucher />} />
            <Route path="/schriftstellerei/gefangnis" element={<Gefangnis />} />
            <Route path="/schriftstellerei/drehbuch" element={<Drehbuch />} />
            <Route path="/schriftstellerei/lieder" element={<Lieder />} />
            <Route path="/schriftstellerei/woche" element={<Woche />} />

            <Route path="/kinotheater/sohnluzifers" element={<SohnLuzifersKTL />} />
            <Route path="/kinotheater/gedichte" element={<GedichteKTL />} />
            <Route path="/kinotheater/zombi" element={<Zombi />} />

            <Route path="museum" element={<Museum />} />
            <Route path="/museum/gedichtespm" element={<GedichteSPM />} />
            <Route path="/museum/lesungen" element={<Lesungen />} />
            <Route path="/museum/lesungen/antiwelt" element={<Antiwelt />} />
            <Route path="/museum/lesungen/teufel" element={<Teufel />} />
            <Route path="/museum/lesungen/zombie" element={<Zombie />} />
            <Route path="/museum/gefangnis123" element={<Gefangnis123 />} />
            <Route path="/museum/gefangnis123/gefangnis2011" element={<Gefangnis2011 />} />
            <Route path="/museum/gefangnis123/gefangnis2" element={<Gefangnis2 />} />
            <Route path="/museum/gefangnis123/gefangnis2009" element={<Gefangnis2009 />} />
            <Route path="/museum/gefangnis123/gefangnis2012" element={<Gefangnis2012 />} />
            <Route path="/museum/polwirt" element={<Polwirt />} />
            <Route path="/museum/polwirt/politik1" element={<Politik1 />} />
            <Route path="/museum/polwirt/politik2" element={<Politik2 />} />
            <Route path="/museum/polwirt/publizistik" element={<Publizistik />} />
            <Route path="/museum/polwirt/geschichterf" element={<GeschichteRF />} />
            <Route path="/museum/pyrammmida" element={<Pyrammmida />} />
            <Route path="/museum/pesenki" element={<Pesenki />} />
            <Route path="/museum/musikserien" element={<MusikSerien />} />
            <Route path="/museum/andere" element={<Andere />} />
            <Route path="/museum/andere/kim" element={<IdeologyKim />} />

            <Route path="/lk" element={<LK />} />
            <Route path="/lk/favoriten" element={<Favoriten />} />
            <Route path="/search" element={<SearchResults />} />

            <Route path="wos" element={<Wos />} />
            <Route path="terms" element={<Krug13 />} />
            <Route path="/ideology/kodex" element={<IdeologyK />} />

            <Route path="/schriftstellerei/sohnluzifers/jack" element={<Jack />} />
            <Route path="/schriftstellerei/sohnluzifers/anfang" element={<Anfang />} />
            <Route path="/schriftstellerei/gefangnis/gefangnistagebucher" element={<Gefangnistagebucher />} />
            <Route path="/schriftstellerei/gefangnis/karzer" element={<Karzer />} />
            <Route path="/schriftstellerei/gefangnis/zweiundvierzig" element={<Zweiundvierzig />} />
            <Route path="/schriftstellerei/gefangnis/gazprom" element={<Gazprom />} />
            <Route path="/kinotheater/zombi/zombi1" element={<Zombi1 />} />
            <Route path="/kinotheater/zombi/zombi2" element={<Zombi2 />} />
            <Route path="/kinotheater/zombi/zombi3" element={<Zombi3 />} />

            {generateRoutes()}
          </Route>
        </Routes>
      </Suspense>
    </div>
    </HelmetProvider>
  );
};

export default App;